<template>
  <div class="container">
    <div class="header-document-metadata">
      <h4 class="document-title">{{ reference.name }}</h4>
    </div>
    <div class="metadata-container">
      <div v-for="{ value, label } in metadata" :key="label" class="label-value-container">
        <span class="label">{{ label }}</span>
        <span class="value">{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

import { getAllMetadataFields } from '~/utils/metadata';
import useDocuments from '~/composables/useDocuments';

export default {
  setup() {
    const { selectedReference: reference } = useDocuments();

    const metadata = computed(() => getAllMetadataFields(reference.value));

    return {
      metadata,
      reference,
    };
  },
};
</script>
<style scoped lang="scss">
.container {
  @include bb-base-font-family;
  @include bb-regular-text-styles('md');

  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  padding: $bb-spacing-3 $bb-spacing-4 $bb-spacing-4 $bb-spacing-4;

  .header-document-metadata {
    padding-bottom: $bb-spacing-3;

    .document-title {
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 122.222% */
      letter-spacing: -0.3px;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
  }

  .metadata-container {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: $bb-spacing-2;
  }

  .label-value-container {
    display: contents;
  }

  .label {
    color: $bb-neutral-3;
    text-align: left;
    padding-right: $bb-spacing-2;
  }

  .value {
    word-break: break-word;
  }
}
</style>
